'use es6';

import PropTypes from 'prop-types';
import { useState, useCallback, useEffect, useRef } from 'react';
import CalloutPopoverBodyBranch from 'rich-text-lib/components/callouts/CalloutPopoverBodyBranch';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import { CALLOUT_ATTRIBUTE } from '../constants/hscallout';
import TinyMcePopover from './TinyMcePopover';
import withPopoverModeState from './withPopoverModeState';
import { jsx as _jsx } from "react/jsx-runtime";
const MCE_SELECTED_ATTRIBUTE = 'data-mce-selected';
const propTypes = {
  editor: PropTypes.object,
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)).isRequired,
  onModeChange: PropTypes.func.isRequired,
  onCalloutTypeChange: PropTypes.func.isRequired,
  onCalloutRemove: PropTypes.func.isRequired,
  eventKey: PropTypes.string.isRequired
};
function CalloutPopoverManagerV2(props) {
  const {
    editor,
    mode,
    onModeChange,
    onCalloutTypeChange,
    onCalloutRemove,
    eventKey
  } = props;
  const [target, setTarget] = useState(null);
  const [calloutType, setCalloutType] = useState(null);
  const [refreshKey, setRefreshKey] = useState('');
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      editor.dom.setAttrib(lastTarget.current, MCE_SELECTED_ATTRIBUTE, null);
      setTarget(null);
    }
  }, [editor]);
  useEffect(() => {
    const handleHsNodeChange = ({
      element
    }) => {
      if (!element) {
        handleRemove();
        return;
      }
      if (element !== lastTarget.current) {
        editor.dom.setAttrib(lastTarget.current, MCE_SELECTED_ATTRIBUTE, null);
        editor.dom.setAttrib(element, MCE_SELECTED_ATTRIBUTE, '1');
        setCalloutType(editor.dom.getAttrib(element, CALLOUT_ATTRIBUTE));
        onModeChange(PopoverBodyMode.PREVIEW);
        setTarget(element);
      } else {
        // We need this dummy prop for CalloutPopoverBodyBranch to force a
        // re-render so tether updates after content changes if that
        // resulted in a height change of the callout div
        setRefreshKey(element.getBoundingClientRect().height);
      }
    };
    editor.on(`hsNodeChange:${eventKey}`, handleHsNodeChange);
    return () => editor.off(`hsNodeChange:${eventKey}`, handleHsNodeChange);
  }, [editor, onModeChange, handleRemove, eventKey]);
  const handleCalloutTypeChange = type => {
    onCalloutTypeChange(target, type);
    setCalloutType(type);
  };
  return /*#__PURE__*/_jsx(TinyMcePopover, {
    editor: editor,
    target: target,
    open: !!target,
    onRemove: handleRemove,
    placement: mode === PopoverBodyMode.EDIT ? 'right' : 'bottom',
    autoPlacement: "horiz",
    closeOnOutsideClick: true,
    renderContent: () => /*#__PURE__*/_jsx(CalloutPopoverBodyBranch, {
      refreshKey: refreshKey,
      mode: mode,
      onModeChange: onModeChange,
      calloutType: calloutType,
      onCalloutTypeChange: handleCalloutTypeChange,
      onCalloutRemove: onCalloutRemove.bind(null, target)
    })
  });
}
CalloutPopoverManagerV2.propTypes = propTypes;
CalloutPopoverManagerV2.displayName = 'CalloutPopoverManagerV2';
export default withPopoverModeState(CalloutPopoverManagerV2);